export { default as Auth } from './containers'



// WEBPACK FOOTER //
// ./src/Auth/index.js